import Route from '@ember/routing/route'
import type Transition from '@ember/routing/transition'
import { task, timeout } from 'ember-concurrency'
import { Product } from 'teacher-ui-client/utils/products'
import type { Precinct } from 'teacher-ui-client/utils/precincts'
import { isPrecinct, isValidPrecinctForProduct, defaultPrecinctForProduct } from 'teacher-ui-client/utils/precincts'
import { service } from '@ember/service'
import { deserializeFilterPhase } from 'teacher-ui-client/components/lessons/fast-phonics/phase-filters'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import { queryParam } from 'teacher-ui-client/decorators/query-param'

export default class FastPhonicsLessonsPreviewsRoute extends Route {
  @service contentfulClient!: ContentfulClient

  @queryParam('subscription-type/lessons') precinct!: string

  model(params: unknown, transition: Transition) {
    const precinct =
      isPrecinct(this.precinct) && isValidPrecinctForProduct(Product.FP, this.precinct)
        ? this.precinct
        : defaultPrecinctForProduct(Product.FP)

    const filterPhase = transition.to?.queryParams.filterPhase
    const selectedPhases = deserializeFilterPhase(typeof filterPhase === 'string' ? filterPhase : '')

    return {
      loaderInstance: this.fetchEntries.perform([precinct], selectedPhases),
    }
  }

  fetchEntries = task({ restartable: true }, async (precincts: Precinct[], selectedPhases?: number[]) => {
    await timeout(500)
    const lessonPreviews = await this.contentfulClient.getLessonPreviews(precincts, { phases: selectedPhases })

    // Get all LessonResources that link to the same LessonData
    const lessonDataEntryIds = lessonPreviews.reduce<string[]>(
      (ids, entry) => (entry.fields.lessonData ? [...ids, entry.fields.lessonData.sys.id] : ids),
      [],
    )
    const resourcesByLessonData = await this.contentfulClient.getLessonResourcesForLessonData(lessonDataEntryIds)
    return { lessonPreviews, resourcesByLessonData }
  })
}
